import React from 'react'

// components
import ResponsiveButton from 'components/atoms/ResponsiveButton'

const EditButton = props => {
  const { parent, reupRequired, align } = props
  const path = `/parents/${parent.id}/edit`
  const color = reupRequired && parent.confirmed ? 'primary' : 'secondary'

  return (
    <ResponsiveButton to={path} color={color} align={align}>
      {parent.confirmed ? 'Edit' : 'Confirm'}
    </ResponsiveButton>
  )
}

export default EditButton
